import React, { useState } from 'react';

const initialPermissions = {
  heading1: false,
  heading2: false,
  subheading1: false,
  subheading2: false,
  // Add more headings and subheadings as needed
};

const ManageUser = () => {
  const [permissions, setPermissions] = useState(initialPermissions);

  const handlePermissionChange = (heading, subheading = null) => {
    setPermissions(prevPermissions => ({
      ...prevPermissions,
      [heading]: subheading ? { ...prevPermissions[heading], [subheading]: !prevPermissions[heading][subheading] } : !prevPermissions[heading],
    }));
  };

  return (
    <div className="container mx-auto mt-8">
      <h2 className="text-xl font-bold">Heading 1</h2>
      <input
        type="checkbox"
        className="form-checkbox mt-2"
        checked={permissions.heading1}
        onChange={() => handlePermissionChange('heading1')}
      />

      <h2 className="text-xl font-bold mt-4">Heading 2</h2>
      <input
        type="checkbox"
        className="form-checkbox mt-2"
        checked={permissions.heading2}
        onChange={() => handlePermissionChange('heading2')}
      />

      <h3 className="text-lg font-bold mt-4">Subheading 1</h3>
      <input
        type="checkbox"
        className="form-checkbox mt-2"
        checked={permissions.heading1 && permissions.subheading1}
        onChange={() => handlePermissionChange('heading1', 'subheading1')}
      />

      <h3 className="text-lg font-bold mt-4">Subheading 2</h3>
      <input
        type="checkbox"
        className="form-checkbox mt-2"
        checked={permissions.heading1 && permissions.subheading2}
        onChange={() => handlePermissionChange('heading1', 'subheading2')}
      />

      {/* Add more headings and subheadings as needed */}
    </div>
  );
};

export default ManageUser;
